export const apiUrl = process.env.REACT_APP_API_URL;
export const paginatedSize = 10;
export const rolesUsers = [
  'administrador',
  'administrativo',
  'profesional'
]

export const civilStatus = [
  'Soltero',
  'Casado',
  'Divorciado',
  'Viudo'
]

export const levelSchool = [
  'Primario',
  'Secundario',
  'Universitario',
  'Posgrado'
]

export const usersTypeStyled = {
  administrador: '#4c82c5',
  administrativo: '#ef5350',
  profesional: '#4caf50'
}

export const ERRORS = {
  AUTH_LOGIN: 'Usuario o contraseña incorrectos.'
}

export const rolesUsersRoutes = {
  superadmin: 'superadmin',
  administrador: 'administrador',
  administrativo: 'administrativo',
  profesional: 'profesional',
  paciente: 'paciente'
}